import React, { FC, useState } from 'react';
import styles from './password-input.module.css';

// Images
import showPasswordImage from '../../images/password-show.svg';
import hidePasswordImage from '../../images/password-hide.svg';

// The same show/hide affordance InputField gives the login screen, packaged so the forms that use a
// plain <input> can have it too — see input-field.tsx.
const PasswordInput: FC<{
  id: string;
  name?: string;
  placeholder?: string;
  defaultValue?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}> = ({ id, name, placeholder, defaultValue, className, onChange, onBlur }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={styles.passwordInputContainer}>
      <input
        id={id}
        name={name}
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        defaultValue={defaultValue}
        className={className}
        onChange={onChange}
        onBlur={onBlur}
      />
      <img
        className={styles.showPasswordButton}
        src={showPassword ? hidePasswordImage : showPasswordImage}
        alt={showPassword ? 'Esconder senha' : 'Mostrar senha'}
        title={showPassword ? 'Esconder senha' : 'Mostrar senha'}
        onClick={() => setShowPassword(!showPassword)}
      />
    </div>
  );
};

export default PasswordInput;
